const gtmChangePasswordClicked = () => {
    dataLayer.push({
        event: 'forgot_password',
        step: 'submit_new_password',
        _clear: true,
    })
}

export default gtmChangePasswordClicked
